module.exports = __webpack_public_path__ + "img/d8c37e2.webp";